<div *ngIf="isLoading$ | async" class="container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
